export class Helper {
  public static showNextPageButton(skip: number, take: number, totalCount: number): boolean {
    return (skip + take) - totalCount < 0;
  }

  public static getRandomStringKey(): string {
    return Math.random().toString(36).substring(7);
  }
}
